/** The top bar's tabs, and the paths each one owns. */
export const NAV_TABS = [
  // A saved game opens at /analysis/:gameId, a pasted one at /analyze: both are Review.
  { to: "/analyze", label: "Review", owns: ["/analyze", "/analysis"] },
  { to: "/play", label: "Play", owns: ["/play"] },
  { to: "/library", label: "Library", owns: ["/library"] },
  // The drill session is the Mistakes tab's (named Drill until 2026-10-18).
  { to: "/practice", label: "Mistakes", owns: ["/practice", "/drill"] },
  { to: "/openings", label: "Openings", owns: ["/openings"] },
] as const;

export type NavTab = (typeof NAV_TABS)[number]["to"];

/** The tab that owns a path, by whole segments (so /players isn't Play's), or null (the home, Profile, Pricing). */
export function navTabFor(pathname: string): NavTab | null {
  const tab = NAV_TABS.find((t) => t.owns.some((p) => pathname === p || pathname.startsWith(`${p}/`)));
  return tab?.to ?? null;
}
